var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7h7.5a1 1 0 011 1v6.5M12 18H4.5a1 1 0 01-1-1V9.5",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M23.5 16.234a1 1 0 01-1.514.857l-3-1.8a1 1 0 01-.486-.857v-3.868a1 1 0 01.486-.857l3-1.8a1 1 0 011.514.857v7.468z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.5 3l18 18",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04IDdIMTUuNUMxNi4wNTIzIDcgMTYuNSA3LjQ0NzcyIDE2LjUgOFYxNC41IiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyIDE4SDQuNUMzLjk0NzcyIDE4IDMuNSAxNy41NTIzIDMuNSAxN1Y5LjUiIHN0cm9rZT0iY3VycmVudCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIzLjUgMTYuMjM0QzIzLjQ5OTcgMTYuNTk0IDIzLjMwNTkgMTYuOTI2MSAyMi45OTI2IDE3LjEwMzVDMjIuNjc5MyAxNy4yODA4IDIyLjI5NDggMTcuMjc2IDIxLjk4NiAxNy4wOTFMMTguOTg2IDE1LjI5MUMxOC42ODQ4IDE1LjExMDUgMTguNTAwMyAxNC43ODUyIDE4LjUgMTQuNDM0VjEwLjU2NkMxOC41MDAzIDEwLjIxNDggMTguNjg0OCA5Ljg4OTUgMTguOTg2IDkuNzA4OTlMMjEuOTg2IDcuOTA4OTlDMjIuMjk0OCA3LjcyMzk0IDIyLjY3OTMgNy43MTkxOCAyMi45OTI2IDcuODk2NTNDMjMuMzA1OSA4LjA3Mzg4IDIzLjQ5OTcgOC40MDU5NyAyMy41IDguNzY1OTlWMTYuMjM0WiIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0wLjUgM0wxOC41IDIxIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgVideoOff as ReactComponent };